"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const commentLikeStore_1 = require("./commentLikeStore");
const ucParamAjaxHelper_1 = require("../lib/ucParamAjaxHelper");
const store_1 = require("../../const/store");
const storeEvent_1 = require("../lib/storeEvent");
const inject_1 = require("../lib/inject");
const logServer_1 = require("../lib/logServer");
const fx_1 = require("../lib/fx");
class CommentListV1Store {
    constructor(config) {
        this.isShowStat = false;
        this.hotCnt = 0;
        this.cnt = 0;
        this.loadCnt = {
            hot: 0,
            cnt: 0,
        };
        this.loadCommentList = async (queryIndex, options) => {
            try {
                const url = `@{apiHost}/v2/api/comment/list/${this.config.instance}`;
                const ajax = ucParamAjaxHelper_1.default;
                if (!ajax) {
                    console.error('ucajax not found');
                    throw new Error('ucajax not found');
                }
                const data = await ajax.getJsonWithCommonParams(url, {
                    item_id: this.config.itemId,
                    query_index: queryIndex,
                    get_hot: 0,
                    rule: 'A',
                });
                if (options && options.noUpdate) {
                    return;
                }
                if (options && options.replace) {
                    this.hotItems = [];
                    this.items = [];
                }
                mobx_1.runInAction(() => {
                    if (data.data) {
                        if (data.data.hotComments) {
                            data.data.hotComments.forEach((item) => {
                                this.hotItems.push(item);
                            });
                        }
                        if (data.data.comments) {
                            data.data.comments.forEach((item) => {
                                this.items.push(item);
                            });
                            this.loadCnt.cnt = data.data.comments.length;
                        }
                        this.page++;
                        this.token = data.data.token;
                        this.lastIndex = data.data.lastIndex;
                        this.hasMore = data.data.lastIndex !== -1;
                        this.likeStore.loadStorageData(this.config.itemId, this.items, this.config.instance);
                        storeEvent_1.default.sendEvent('comment:load', {
                            data: data.data,
                        });
                    }
                });
            }
            catch (ex) {
                // todo
            }
        };
        this.onAddCommentEvent = (newItem) => {
            this.myItems.unshift(newItem);
        };
        this.config = config;
        this.total = config.total || 0;
        this.lastIndex = config.lastIndex || -1;
        this.items = this.config.items || [];
        this.hotItems = this.config.hotItems || [];
        this.loadCnt = {
            hot: this.hotItems.length,
            cnt: this.hotItems.length + this.items.length,
        };
        this.myItems = [];
        this.hasMore = config.lastIndex !== -1;
        this.page = 0;
        this.token = config.commentToken;
        this.initStoreEventHandler();
        mobx_1.reaction(() => this.total, (total) => {
            storeEvent_1.default.sendEvent('commentInput:total:change', {
                data: { total },
            });
        });
        if (!inject_1.default.has(store_1.StoreName.CommentLikeStore)) {
            inject_1.default.register(store_1.StoreName.CommentLikeStore, commentLikeStore_1.default, {});
        }
        this.likeStore = inject_1.default.get(store_1.StoreName.CommentLikeStore);
        this.likeStore.loadStorageData(this.config.itemId, this.hotItems, this.config.instance);
        this.likeStore.loadStorageData(this.config.itemId, this.items, this.config.instance);
        storeEvent_1.default.sendEvent('comment:init', {
            data: this.config,
        });
    }
    get commentLength() {
        return this.myItems.length + this.hotItems.length + this.items.length;
    }
    updateLike(commentItem) {
        this.likeStore.updateLike(commentItem, 'comment', this.token);
        storeEvent_1.default.sendEvent('comment:like', {
            data: commentItem,
        });
    }
    updateReplyLike(replyItem) {
        this.likeStore.updateLike(replyItem, 'reply', this.token);
        storeEvent_1.default.sendEvent('comment:replyLike', {
            data: replyItem,
        });
    }
    initStoreEventHandler() {
        storeEvent_1.default.addEventHandler('commentInput:add:comment', (event) => {
            this.onAddCommentEvent(event.data.newItem);
        });
        storeEvent_1.default.addEventHandler('commentInput:afterAdd:comment', (event) => {
            this.myItems[0].commentId = event.data.newItem.commentId;
            this.loadCommentList(0, { noUpdate: true });
            const newItem = event.data.newItem;
            storeEvent_1.default.sendEvent('comment:add', {
                data: newItem,
            });
        });
        storeEvent_1.default.addEventHandler('commentInput:init:history', (event) => {
            const historyItems = event.data.commentItems;
            historyItems.forEach((item) => {
                if (this.hotItems.find((findItem) => {
                    return findItem.commentId === item.commentId;
                })) {
                    return;
                }
                if (this.items.find((findItem) => {
                    return findItem.commentId === item.commentId;
                })) {
                    return;
                }
                this.onAddCommentEvent(item);
            });
        });
        storeEvent_1.default.addEventHandler('comment:add', (event) => {
            const commentItem = event.data;
            const imageCount = commentItem.images ? commentItem.images.length : 0;
            logServer_1.commentLogger().log({
                ac: 'comment_action',
                item_id: commentItem.itemId,
                comment_ref_id: commentItem.commentRefId,
                comment_id: commentItem.commentId,
                is_hot: commentItem.isHot ? 1 : 0,
                action: 'cmt',
                images_count: imageCount,
                num: 0,
            });
        });
        storeEvent_1.default.addEventHandler('comment:like', (event) => {
            const commentItem = event.data;
            logServer_1.commentLogger().log({
                ac: 'comment_action',
                item_id: commentItem.itemId,
                comment_ref_id: commentItem.commentRefId,
                comment_id: commentItem.commentId,
                is_hot: commentItem.isHot ? 1 : 0,
                action: commentItem.isLike ? 'like' : 'unlike',
            });
        });
        storeEvent_1.default.addEventHandler('comment:replyLike', (event) => {
            const replyItem = event.data;
            logServer_1.commentLogger().log({
                ac: 'comment_action',
                item_id: replyItem.itemId,
                comment_ref_id: replyItem.commentRefId,
                comment_id: replyItem.commentId,
                reply_id: replyItem.replyId,
                is_hot: replyItem.isHotComment ? 1 : 0,
                action: replyItem.isLike ? 'like' : 'unlike',
            });
        });
        storeEvent_1.default.addEventHandler('comment:load', (event) => {
            this.isShowStat = false;
        });
        storeEvent_1.default.addEventHandler('comment:click', (event) => {
            const commentItem = event.data;
            logServer_1.commentLogger().log({
                ac: 'comment_clk',
                item_id: commentItem.itemId,
                comment_ref_id: commentItem.commentRefId,
                comment_id: commentItem.commentId,
                is_hot: commentItem.isHot ? 1 : 0,
            });
        });
        storeEvent_1.default.addEventHandler('comment:expo', (event) => {
            const commentItem = event.data;
            if (commentItem.isHot) {
                this.hotCnt++;
            }
            this.cnt++;
            if (!this.isShowStat) {
                logServer_1.commentLogger().log({
                    ac: 'comment_show',
                    hot_cnt: this.loadCnt.hot,
                    cnt: this.loadCnt.cnt,
                });
                this.isShowStat = true;
            }
            const bodyParams = logServer_1.commentLogger().getCommonBodyParams();
            fx_1.callJssdk('nfbase.onNotify', {
                notify_id: 'statCommentExpo',
                notify_params: Object.assign(bodyParams, {
                    ac: 'comment_expo',
                    hot_cnt: this.hotCnt,
                    cnt: this.cnt,
                    total: this.total,
                }),
            }).catch((data) => {
                logServer_1.commentLogger().log({
                    ac: 'comment_expo',
                    hot_cnt: this.hotCnt,
                    cnt: this.cnt,
                    total: this.total,
                });
            });
        });
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], CommentListV1Store.prototype, "total", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], CommentListV1Store.prototype, "lastIndex", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], CommentListV1Store.prototype, "myItems", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], CommentListV1Store.prototype, "hotItems", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], CommentListV1Store.prototype, "items", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], CommentListV1Store.prototype, "hasMore", void 0);
tslib_1.__decorate([
    mobx_1.computed,
    tslib_1.__metadata("design:type", Object),
    tslib_1.__metadata("design:paramtypes", [])
], CommentListV1Store.prototype, "commentLength", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentListV1Store.prototype, "loadCommentList", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CommentListV1Store.prototype, "updateLike", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CommentListV1Store.prototype, "updateReplyLike", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentListV1Store.prototype, "onAddCommentEvent", void 0);
exports.default = CommentListV1Store;
//# sourceMappingURL=data:application/json;base64,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